import QuantityCounter from '../globals/quantity-handle';
import Media from '../media/media';
import * as a11y from '../vendor/theme-scripts/theme-a11y';

import {showModal} from './modal';
import {ProductAddForm} from './product-form';

const selectors = {
  body: 'body',
  globalWrapper: '[data-quickview-modal-global]',
  modal: '[data-quickview-modal]',
  outer: '[data-product-grid-item]',
  content: '[data-quickview-content]',
  handle: 'data-trigger-quickview',
  productSlides: '.product__slides',
  sliderEnabled: 'flickity-enabled',
  reviews: 'data-reviews',
};
const defaultHTML = '<div class="loader loader--quickview"><div class="loader-indeterminate"></div></div>';

/**
 * Button constructor, triggered for each button by Quickview
 */
export default class QuickviewButton {
  constructor(button, id) {
    this.button = button;
    this.outerSectionId = id;
    this.handle = this.button.getAttribute(selectors.handle);
    this.unique = this.handle + '_' + this.outerSectionId;
    this.outer = this.button.closest(selectors.outer);
    this.modal = this.outer.querySelector(selectors.modal);
    this.globalWrapper = document.querySelectorAll(selectors.globalWrapper)[0];
    this.content = this.modal.querySelector(selectors.content);
    this.clone = this.modal;
    this.cloneContent = this.content;
    this.body = document.querySelector(selectors.body);
    this.accessibility = a11y;
    this.form = {};
    this.init();
  }

  init() {
    this.initButton();
    this.initFetch();
  }

  initFetch() {
    const self = this;
    this.modal.addEventListener(
      'quickview',
      function () {
        self.renderProduct();
      },
      false
    );
  }

  renderProduct() {
    const self = this;
    this.clone = this.modal.cloneNode(true);
    this.globalWrapper.append(this.clone);
    this.cloneContent = this.clone.querySelector(selectors.content);

    showModal(self.clone, self.onOpen.bind(self), self.onClose.bind(self));

    const root = window.theme.routes.root === '/' ? '' : window.theme.routes.root;

    fetch(root + '/products/' + self.handle + '?view=ajax_quickview')
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const regex = /CORGIPOMSKIMELONFELLOW/gi;
        const newData = data.replace(regex, self.unique);
        self.cloneContent.innerHTML = newData;
        self.onLoaded();
      })
      .catch(function () {
        console.log('error');
      });
  }

  initButton() {
    const self = this;
    const initButtons = this.outer.querySelectorAll(`[${selectors.handle}='${this.handle}']`);
    if (initButtons.length) {
      initButtons.forEach((element) => {
        element.addEventListener('click', function (e) {
          e.preventDefault();

          const eventQuickview = new CustomEvent('quickview', {
            handle: self.handle,
          });

          self.modal.dispatchEvent(eventQuickview);
        });
      });
    }
  }

  onLoaded() {
    const slider = this.cloneContent.querySelector(selectors.productSlides);
    const hasSlider = slider.classList.contains(selectors.sliderEnabled);
    const showReviews = this.cloneContent.getAttribute(selectors.reviews) !== 'false';
    const reviewsAppInstalled = typeof window.SPR === 'function';
    const section = {
      id: this.unique,
      container: this.cloneContent,
      type: 'quickview',
    };

    if (hasSlider) {
      window.dispatchEvent(new Event('resize'));
    } else if (typeof window.theme.mediaInstances[this.id] === 'undefined') {
      window.theme.mediaInstances[this.unique] = new Media(section);
      window.theme.mediaInstances[this.unique].init();
    } else {
      window.theme.mediaInstances[this.unique].initSlider();
    }

    this.form = new ProductAddForm(section);
    const counter = new QuantityCounter(section.container);
    counter.init();

    if (showReviews && reviewsAppInstalled) {
      window.SPR.initDomEls();
      window.SPR.loadProducts();
      window.SPR.loadBadges();
    }

    const event = new CustomEvent('modal-is-loaded', {
      bubbles: true,
    });

    this.globalWrapper.dispatchEvent(event);

    this.accessibility.trapFocus(this.clone, {
      elementToFocus: this.clone.querySelector('a:first-child, input:first-child'),
    });

    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.PaymentButton !== 'undefined' && typeof window.Shopify.PaymentButton.init !== 'undefined') {
      window.Shopify.PaymentButton.init();
    }
  }

  onOpen() {
    // unused for now
  }

  onClose() {
    if (Object.keys(this.form).length !== 0 && this.form.constructor === Object) {
      this.form.destroy();
    }
    this.content.innerHTML = defaultHTML;

    this.accessibility.removeTrapFocus();

    if (this.body.classList.contains('is-focused')) {
      const button = document.querySelector(`[data-trigger-quickview="${this.handle}"]`);

      setTimeout(() => {
        button.focus();
      }, 200);
    }

    while (this.globalWrapper.firstChild) this.globalWrapper.removeChild(this.globalWrapper.firstChild);
  }
}
